// extracted by mini-css-extract-plugin
module.exports = {"product-search-category-list__option":"ProductSearchRefinementCategoryList_product-search-category-list__option__CT7i5"};